import { generateUtilityClass, generateUtilityClasses } from '../className';
export function getSvgIconUtilityClass(slot) {
  return generateUtilityClass('JoySvgIcon', slot);
}
const svgIconClasses = generateUtilityClasses('JoySvgIcon', ['root', 'colorInherit', 'colorPrimary', 'colorNeutral', 'colorDanger', 'colorInfo', 'colorSuccess', 'colorWarning', 'fontSizeInherit', 'fontSizeXs', 'fontSizeSm', 'fontSizeMd', 'fontSizeLg', 'fontSizeXl', 'fontSizeXl2', 'fontSizeXl3', 'fontSizeXl4', 'fontSizeXl5', 'fontSizeXl6']);
export default svgIconClasses;